import React from "react";
import { tabla } from "../../assets";
import "./Banner.css";
import { motion } from "framer-motion";

const Banner = () => {
  return (
    <div className="home" id="home">
      <div className="container display-f">
        <div className="">
          <motion.div
            initial={{ x: -70, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.5 }}
          >
            {" "}
            <h1>
              Welcome to <br />
              <span>SNK music store</span>
            </h1>
          </motion.div>
          <motion.div
            initial={{ x: -70, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ delay: 1, duration: 1 }}
          >
            <p>
              Unleash your musical creativity with SNK Music Store's exquisite
              collection. Let your journey into sound begin here.
            </p>
          </motion.div>
        </div>
        <div className="">
          <motion.div
            initial={{ x: 70, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.5 }}
          >
            <img src={tabla} alt="" />
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Banner;

// import React from "react";
// import { tabla } from "../../assets";
// import "./Banner.css";
// import { motion } from "framer-motion";
// import { useInView } from "react-intersection-observer";

// const Banner = () => {
//   const { ref, inView } = useInView({
//     threshold: 0.7, // Trigger animation when 50% of the component is visible
//   });

//   return (
//     <div className="home" id="home">
//       <div className="container display-f">
//         <div className="">
//           <motion.div
//             ref={ref}
//             initial={{ x: -20, opacity: 0 }}
//             animate={inView ? { x: 0, opacity: 1 } : {}}
//             transition={{ delay: 0.4, duration: 0.4 }}
//           >
//             {" "}
//             <h1>
//               Welcome to <br />
//               <span>SNK music store</span>
//             </h1>
//           </motion.div>
//           <motion.div
//             ref={ref}
//             initial={{ x: -70, opacity: 0 }}
//             animate={inView ? { x: 0, opacity: 1 } : {}}
//             transition={{ delay: 0.8, duration: 0.8 }}
//           >
//             <p>
//               Unleash your musical creativity with SNK Music Store's exquisite
//               collection. Let your journey into sound begin here.
//             </p>
//           </motion.div>
//         </div>
//         <div className="">
//           <motion.div
//             ref={ref}
//             initial={{ x: 70, opacity: 0 }}
//             animate={inView ? { x: 0, opacity: 1 } : {}}
//             transition={{ delay: 0.5, duration: 0.5 }}
//           >
//             <img src={tabla} alt="" />
//           </motion.div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Banner;
